import React from "react";
import OrdersList from "./OrderList";
import { PageContainer } from "../../../components";
import { ApolloProvider } from "@apollo/react-hooks";
import { UserClient } from "../../../api/apolloClient";
import { Redirect, withRouter, RouteComponentProps } from "react-router-dom";
import { useUser } from "../../../userContext";

interface Props {
  // the user in the URL of the page
  userID: string;
}

// a user that is not in a group has the nil UUID as their group
const NO_GROUP = "00000000-0000-0000-0000-000000000000";

const OrdersView: React.FC<Props & RouteComponentProps> = ({
  userID,
  history,
}) => {
  const { user } = useUser();
  const groupID =
    user.groupID && NO_GROUP !== user.groupID ? user.groupID : undefined;
  // The orders shown are always those of the signed in user. The URL can name
  // another user, such as the previous one to sign in on this browser.
  if (!user.id) {
    return null;
  }
  if (userID !== user.id) {
    return <Redirect to={`/user/${user.id}/orders`} />;
  }
  return (
    <PageContainer
      title="Orders"
      subtitle="Orders for your group, and for its child groups, are shown here. Generator override is only available on your own orders."
      maxWidth={false}
    >
      <ApolloProvider client={UserClient}>
        <OrdersList
          userID={user.id}
          groupID={groupID}
          onDCXDash={(e): void =>
            history.push(
              `/dcx/${e.order.docID}/dashboard?dash_name=${e.order.name}`
            )
          }
          canViewDCX={true}
        />
      </ApolloProvider>
    </PageContainer>
  );
};

export default withRouter(OrdersView);
